import { Flex } from 'modules/ui/flex';
import { theme } from 'modules/ui/theme';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const StyledSearchResults = styled(Flex)`
  justify-content: flex-start;
  gap: 1.25rem;

  width: 100%;
  max-height: 32rem;
  overflow-y: auto;

  font-size: ${theme.fontSizes.h4};
  color: ${theme.colors.primaryW};

  margin-top: 1.938rem;
  margin-bottom: 3.563rem;

  ${mediaQuery('md')} {
    margin-top: 4.563rem;
    margin-bottom: 0rem;
  }
`;
